//component entry file
import CompanyEvaluate from "./components/companyEvaluate/CompanyEvaluate.vue";
import CompanyReport from "./components/companyEvaluate/CompanyReport.vue";

export {
    CompanyReport
};

export default CompanyEvaluate;